module.exports = __webpack_public_path__ + "static/media/kitchenette.f2a6961e.jpg";